export default {
    auth_url: 'API/parkphone/u/auth?userType=',
    cacl_url: 'API/pay/out/queryFee',
    loadUserInfo_url: 'API/parkphone/u/load',
    loadParks_url: 'API/parkphone/parks/list',
    loadParkInfo_url: 'API/parkphone/parkInfo/list',
    loadMyCar_url: 'API/parkphone/parkPhoneCar/list',
    addCar_url: 'API/parkphone/parkPhoneCar/add',
    parkMsg_url: 'API/parkphone/parkMessage/list',
    delCar_url: 'API/parkphone/parkPhoneCar/delete',
    opinion_url: 'API/parkphone/parkOpinion/add',
    uploadFile_url: 'API/parkphone/parkFile/uploadFile',
    order_url: 'API/parkphone/order/query',
    parksGetById_url: 'API/parkphone/parks/getById',
    parkInfoGetById_url: 'API/parkphone/parkInfo/getById',
    pay_url: 'API/pay/out/commonOrder',
    sms_url: 'API/parkphone/u/sendSms',
    phone_url: "API/parkphone/u/loginH5",
    skt_cacl_url: "wss://atest.yytelec.com/API/calc",
}



// WEBPACK FOOTER //
// ./src/api/index.js